import { callGetApiToServer } from "../callApi";

export async function getAllCourseReview(authtoken, skipNumber, limitNumber, courseId) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    let endUrl = `v1/course-reviews/${courseId}?skip=${skipNumber}&limit=${limitNumber}`;

    let responseData = await callGetApiToServer(header, "GET", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
